module.exports = __webpack_public_path__ + "static/img/products_Ecell.9756a332.png";